(()=>{
  const config=JSON.parse(document.getElementById('bs-interaction-config')?.textContent||'{}');
  let queued=false,lastBottom=-1;
  const measured=new WeakSet();
  const resizeObserver=new ResizeObserver(schedule);
  const classObserver=new MutationObserver(schedule);
  function addUtilities(){
    document.querySelectorAll('.bs-demo').forEach(root=>{
      const extras=root.querySelector('.mobile-nav .nav-mobile-extras');
      if(!extras)return;
      root.querySelectorAll('.site-header .bs-account-tools a').forEach(source=>{
        const path=new URL(source.href,location.origin).pathname;
        if(!['/search','/account'].includes(path)||extras.querySelector('[data-bs-utility="'+path+'"]'))return;
        const link=document.createElement('a');link.href=source.getAttribute('href');link.dataset.bsUtility=path;
        link.textContent=source.getAttribute('aria-label')||source.getAttribute('title')||(path==='/search'?config.search:config.account);
        extras.append(link);
      });
    });
  }
  function quoteEntry(){
    if(!document.body.classList.contains('bs-page-quote'))return;
    const main=document.getElementById('MainContent');
    const app=main?.querySelector('[id*="upform_section"]');
    const banner=main?.querySelector('.page-default__banner');
    if(!app||!banner)return;
    if(!document.getElementById('bs-quote-form')){
      const anchor=document.createElement('span');anchor.id='bs-quote-form';anchor.tabIndex=-1;app.prepend(anchor);
      const entry=document.createElement('div');entry.className='bs-quote-entry';
      const link=document.createElement('a');link.href='#bs-quote-form';link.textContent=config.quoteStart;entry.append(link);banner.after(entry);
    }
    const form=app.querySelector('form');
    let status=app.querySelector('.bs-quote-loading');
    if(form&&form.querySelector('input:not([type="hidden"])')){status?.remove();return;}
    if(!status){status=document.createElement('p');status.className='bs-quote-loading';status.setAttribute('role','status');status.textContent=config.quoteLoading;app.prepend(status);}
  }
  function update(){
    queued=false;
    document.body.classList.toggle('bs-ui-scrolled',scrollY>48);
    addUtilities();quoteEntry();
    let bottom=0;
    document.querySelectorAll('#bs-cta-bar,.bs-config-summary,.bs-showcase-summary,.compare-dock').forEach(bar=>{
      if(!measured.has(bar)){resizeObserver.observe(bar);classObserver.observe(bar,{attributes:true,attributeFilter:['class','hidden','style']});measured.add(bar);}
      const rect=bar.getBoundingClientRect(),style=getComputedStyle(bar);
      if(!bar.hidden&&!bar.classList.contains('bs-hidden')&&style.display!=='none'&&style.visibility!=='hidden'&&Number(style.opacity)!==0&&rect.height>0&&rect.top<innerHeight&&rect.bottom>innerHeight-350&&['fixed','sticky'].includes(style.position))bottom=Math.max(bottom,Math.min(innerHeight,innerHeight-rect.top));
    });
    bottom=Math.ceil(bottom);
    if(lastBottom!==bottom){document.documentElement.style.setProperty('--bs-ui-bottom',bottom+'px');lastBottom=bottom;}
  }
  function schedule(){if(!queued){queued=true;requestAnimationFrame(update);}}
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);schedule();
})();
